import { $api } from "../../../../services/request.config";
import { clearClaims, fetchClaimsSuccess } from "../claimsActions";

export const fetchClaimsThunk = () => async (dispatch) => {
    try {
        const response = await $api.get("/v1/c/claims");
        const claimsData = response.data && response.data.data;
        const claims = Array.isArray(claimsData) ? claimsData : [];
        dispatch(fetchClaimsSuccess(claims));
        return claims;
    } catch (error) {
        dispatch(clearClaims());
        return [];
    }
};
